/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/29/14
 * Time: 7:03 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";
    var CP_CONST = require("connection-const");
    var Loader = require("ui/loader/Loader");
    var AreaSnippetsCollection = require("connection-collections/KPsTab/AreaSnippetsCollection");
    var KPsSnippetsCompositeView = require("connection-views/KPsTab/KPsSnippetsCompositeView");
    var KPsSnippetsCompositeModel = require("connection-models/KPsTab/KPsSnippetsCompositeModel");

    var AreaSnippetsController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        AreaSnippetsController = Marionette.Controller.extend({
            referrerAction: CP_CONST.REFERER_ACTION.AREA_SNIPPET,

            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.areaChangeCount = 0;
                var area = this.connectionPanelContextModel.get("context.area");
                if(area){
                    this._onAreaChange( this.connectionPanelContextModel,area);
                }
                this._bindEvents();

            },

            _bindEvents: function () {
                this.listenTo(this.connectionPanelContextModel, "change:context.area", this._onAreaChange, this);
                this.listenTo(this.connectionPanelContextModel, "change:selectedKP", this._onSelectedKPChange, this);
            },


            _onAreaChange: function (model, area) {
                if (area) {
                    if (this.areaChangeCount === 0) {
                        this.areaChangeCount++;
                        this._setLoader();
                        LEConnection.once("page:updated", this._onPageUpdated, this);
                    }
                    this._fetchArea(area);
                }
                else {
                    this._hideSnippetCompositeView();
                }
            },

            _fetchArea: function (area) {
                this.areaSnippetsCollection = this._getAreaSnippetsCollection();
                this.areaSnippetsCollection.fetch({
                    lang: this.connectionPanelContextModel.get("locale"),
                    area: area,
                    userId:this.connectionPanelContextModel.get("userId"),
                    accountId:this.connectionPanelContextModel.get("accountId"),
                    success: _.bind(this._onSuccess, this),
                    error: _.bind(this._onError, this)
                });
            },
            _getAreaSnippetsCollection: function () {
                if (!this.areaSnippetsCollection) {
                    this.areaSnippetsCollection = new AreaSnippetsCollection();
                }
                return this.areaSnippetsCollection;
            },


            _onSuccess: function (collection) {
                LEConnection.logger.debug("AreaSnippetsController:_fetchArea - success");
                this._onAreaUpdated();
                if (collection.length > 0) {
                    this._showSnippetCompositeView();
                }
                else {
                    this._hideSnippetCompositeView();
                }
            },
            _onError: function (options) {
                LEConnection.logger.error("KPsSearchController:_fetchArea - Failed to fetch data");
                this._closeLoader();
                this._getAreaSnippetsCollection().reset();
                this._hideSnippetCompositeView();
                this._setNoData();
                // TODO display error
            },
            _hideSnippetCompositeView: function () {
                LEConnection.vent.trigger("KPsTabController::closeRegion:areaRegion");
            },
            _showSnippetCompositeView: function () {
                if (!this.snippetCompositeView) {
                    this._setSnippetCompositeView();
                }
                if (_.isUndefined(this.snippetCompositeView.isClosed) || this.snippetCompositeView.isClosed) {
                    LEConnection.vent.trigger("KPsTabController::showRegion:areaRegion", {view: this.snippetCompositeView});
                }
            },
            _setSnippetCompositeView: function () {
                var kpsSnippetsCompositeModel = new KPsSnippetsCompositeModel({
                    listTitle: LE.translator.translate("LEConnection." + this.referrerAction)
                });
                this.snippetCompositeView = new KPsSnippetsCompositeView({
                    model: kpsSnippetsCompositeModel,
                    collection: this._getAreaSnippetsCollection(),
                    type: this.referrerAction
                });

            },
            _onSelectedKPChange: function (model, selectedKP) {

                if (this.snippetCompositeView) {
                    if (this.referrerAction === this.connectionPanelContextModel.get("referrerAction") && selectedKP) {
                        var slug = selectedKP.get("slug");
                        this.snippetCompositeView.setSelected(slug);
                    }
                    else {
                        this.snippetCompositeView.unSelectAll();
                    }
                }
            },

            findSlugInCollection: function (slug) {
                var returnedModel;

                if (this.collection) {
                    returnedModel = this.areaSnippetsCollection.findWhere({slug: slug});
                }

                return returnedModel;

            },
            _setLoader: function () {
                LEConnection.vent.trigger("KPsTabController::loader:show");
            },
            _closeLoader: function () {
                LEConnection.vent.trigger("KPsTabController::loader:hide");
            },
            _onPageUpdated: function () {
                this._closeLoader();
            },
            _onAreaUpdated: function () {
                this._closeLoader();
            },
            _setNoData:function(){
                LEConnection.vent.trigger("KPsTabController::noData:show");
            }

        });
    });
    return AreaSnippetsController;
});

